import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromCourses from "../reducers/courses.reducer";

export const getClassesForSubjectState = createSelector(
    fromFeature.getCartState,
    (state: fromFeature.CartState) => state.classesForSubject
);

// these select individual properties on a Course State (data, loading, loaded)
// using the entities, this returns a data object (used for high-performance reading, updating & removing)
export const getClassesForSubjectEntities = createSelector(
    getClassesForSubjectState,
    fromCourses.getClassesForSubjectEntities
);

// this takes data object from 'getCoursesEntities' (above)
// and converts it to a data array so the view can be populated
export const getClassesForSubject = createSelector(
    getClassesForSubjectEntities,
    entities => {
        return Array.from(entities.values());
    }
);

export const getClassesForSubjectLoaded = createSelector(
    getClassesForSubjectState,
    fromCourses.getClassesForSubjectLoaded
);

export const getClassesForSubjectLoading = createSelector(
    getClassesForSubjectState,
    fromCourses.getClassesForSubjectLoading
);
